var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-icon"},[_c('div',{staticClass:"higher"},[_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-pulse"})])])])
}]

export { render, staticRenderFns }